import { useFormContext } from '@/contexts/form-context';
import SettingsFooter from '@/partials/shared/settings/settings-footer';

export default function GeneralPanelFooter() {
  const form = useFormContext();

  return (
    <SettingsFooter>
      <form.Subscribe
        selector={(state) => [state.canSubmit, state.isSubmitting]}
        children={([canSubmit, isSubmitting]) => (
          <>
            <button
              type="button"
              onClick={form.reset}
              disabled={isSubmitting}
              className="btn dark:bg-gray-800 border-gray-200 dark:border-gray-700/60 hover:border-gray-300 dark:hover:border-gray-600 text-gray-800 dark:text-gray-300"
            >
              Avbryt
            </button>
            <button
              disabled={!canSubmit}
              type="submit"
              className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white ml-3"
            >
              {isSubmitting ? 'Sparar ändringar...' : 'Spara ändringar'}
            </button>
          </>
        )}
      />
    </SettingsFooter>
  );
}
